import React from "react";

const ErrorFallback = ({ resetError }) => (
  <div
    style={{
      minHeight: "60vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: "2rem",
    }}
  >
    <h2>Something went wrong</h2>
    <p>Please refresh the page and try again.</p>
    <button
      type="button"
      className="co-btn-primary"
      style={{ marginTop: "1rem" }}
      onClick={() => {
        resetError();
        window.location.reload();
      }}
    >
      Reload Page
    </button>
  </div>
);

export default ErrorFallback;
